export const LOAD = 'channel/LOAD';
export const LOAD_COMPLETED = 'channel/LOAD_COMPLETED';
export const LOAD_FAILED = 'channel/LOAD_FAILED';

export const SAVE = 'channel/SAVE';
export const SAVE_COMPLETED = 'channel/SAVE_COMPLETED';
export const SAVE_FAILED = 'channel/SAVE_FAILED';
